/**
 * Created by razial on 05.06.2026.
 */

cleverapps.OutlineSprite = cc.Node.extend({
    ctor: function (image, options) {
        this._super();

        options = options || {};

        this.image = image;
        this.needCapture = true;
        this.parts = [];

        const styles = cleverapps.styles.OutlineSprite;
        this.outlineWidth = Math.ceil((options.width || styles.width) / 2);
        this.padding = this.outlineWidth + styles.padding;
        this.color = options.color || styles.color;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(image.width + 2 * this.padding, image.height + 2 * this.padding);

        if (typeof gl === "undefined" || !image.width || !image.height) {
            return;
        }

        this.createSprite();
    },

    createSprite: function () {
        const sprite = new cc.Sprite();
        sprite.setScale(1, -1);
        sprite.setPosition(this.width / 2, this.height / 2);
        this.addChild(sprite);

        if (!cc.shaderCache || !cleverapps.Shaders || !cc.shaderCache._programs[cleverapps.Shaders.OUTLINE_SPRITE_KEY]) {
            sprite.removeFromParent();
            return;
        }

        const shaderState = new cc.GLProgramState(cc.shaderCache.getProgram(cleverapps.Shaders.OUTLINE_SPRITE_KEY));
        sprite._renderCmd.setGLProgramState(shaderState);

        this.sprite = sprite;
        this.shaderState = shaderState;

        this.scheduleUpdate();
    },

    acquireTexture: function () {
        const scale = cc.contentScaleFactor();

        const item = cleverapps.OutlineSprite.acquire(this.width * scale, this.height * scale);
        this.texture = item.texture;
        this.framebuffer = item.framebuffer;
        this.needCapture = true;

        const size = this.texture.getContentSize();
        this.sprite.setTexture(this.texture);
        this.sprite.setTextureRect(cc.rect(0, 0, size.width, size.height));
        this.sprite.setBlendFunc(cc.ONE, cc.ONE_MINUS_SRC_ALPHA);
    },

    updateShaderState: function () {
        if (!this.shaderState) {
            return;
        }

        const scale = cc.contentScaleFactor();
        const color = this.color;
        this.shaderState.setUniformVec2("u_step", this.outlineWidth * scale / this.texture.getPixelsWide(), this.outlineWidth * scale / this.texture.getPixelsHigh());
        this.shaderState.setUniformVec4("u_color", color.r / 255, color.g / 255, color.b / 255, color.a / 255);
    },

    onEnter: function () {
        this._super();

        if (this.sprite && !this.texture) {
            this.acquireTexture();
            this.updateShaderState();
        }
    },

    onExit: function () {
        this._super();

        if (this.texture) {
            cleverapps.OutlineSprite.release(this.texture, this.framebuffer);

            this.texture = undefined;
            this.framebuffer = undefined;
        }
    },

    setParts: function (parts) {
        this.parts = parts || [];
        this.needCapture = true;
    },

    update: function () {
        if (!this.texture || !this._visible) {
            return;
        }

        const image = this.image instanceof LazyAsset ? this.image.asset || this.image.preview : this.image;
        if (this.needCapture || this.capturedImage !== image || this.parts.length > 0) {
            this.capture();
            this.capturedImage = image;
            this.needCapture = !(image instanceof cc.Sprite);
        }
    },

    capture: function () {
        const images = [this.image].concat(this.parts.filter((part) => part.parent && part.isVisible()));
        const gl = cc._renderContext;

        const size = this.texture.getContentSizeInPixels();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
        gl.viewport(0, 0, size.width, size.height);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);

        const visible = this._visible;
        this._visible = false;
        images.forEach((image) => {
            this.captureImage(image);
        });
        this._visible = visible;

        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        cc.director.setViewport();
    },

    captureImage: function (image) {
        cc.renderer._turnToCacheMode(this.__instanceId);

        // image vertices carry the render commands' world transform which may lag one frame behind the node properties (e.g. during map scroll) -
        // compose this node's transform in the same space (fresh this -> image transform with the image's render command transform) so they cancel exactly
        const relative = cc.affineTransformConcat(this.getNodeToWorldTransform(), cc.affineTransformInvert(image.getNodeToWorldTransform()));
        const inverse = cc.affineTransformInvert(cc.affineTransformConcat(relative, image._renderCmd._worldTransform));
        const inverseMatrix = new cc.math.Matrix4().identity();
        inverseMatrix.mat[0] = inverse.a;
        inverseMatrix.mat[1] = inverse.b;
        inverseMatrix.mat[4] = inverse.c;
        inverseMatrix.mat[5] = inverse.d;
        inverseMatrix.mat[12] = inverse.tx;
        inverseMatrix.mat[13] = inverse.ty;

        cc.kmGLMatrixMode(cc.KM_GL_PROJECTION);
        cc.kmGLPushMatrix();
        cc.kmGLLoadIdentity();
        cc.kmGLMultMatrix(cc.math.Matrix4.createOrthographicProjection(0, this.width, 0, this.height, -1024, 1024));
        cc.kmGLMultMatrix(inverseMatrix);
        cc.projection_matrix_stack.lastUpdated = cleverapps.OutlineSprite.UPLOAD_TOKEN--;

        (image.spine || image).visit();
        cc.renderer._renderingToBuffer(this.__instanceId);

        cc.kmGLMatrixMode(cc.KM_GL_PROJECTION);
        cc.kmGLPopMatrix();
        cc.kmGLMatrixMode(cc.KM_GL_MODELVIEW);
        cc.projection_matrix_stack.lastUpdated = cleverapps.OutlineSprite.UPLOAD_TOKEN--;
    }
});

cleverapps.OutlineSprite.UPLOAD_TOKEN = -1;

cleverapps.OutlineSprite.SIZE_BUCKET = 128;
cleverapps.OutlineSprite.POOL_LIMIT = 2;
cleverapps.OutlineSprite.pool = [];

cleverapps.OutlineSprite.createOn = function (node, options) {
    const outline = new cleverapps.OutlineSprite(node, options);
    outline.setAlignment(node.width / 2, node.height / 2);
    node.addChild(outline, -1);

    node.outlineSprite = outline;

    return outline;
};

cleverapps.OutlineSprite.acquire = function (width, height) {
    width |= 0;
    height |= 0;

    const gl = cc._renderContext;

    let texWidth = Math.ceil(width / cleverapps.OutlineSprite.SIZE_BUCKET) * cleverapps.OutlineSprite.SIZE_BUCKET;
    let texHeight = Math.ceil(height / cleverapps.OutlineSprite.SIZE_BUCKET) * cleverapps.OutlineSprite.SIZE_BUCKET;
    if (!cc.configuration.supportsNPOT()) {
        texWidth = cc.NextPOT(texWidth);
        texHeight = cc.NextPOT(texHeight);
    }

    const pool = cleverapps.OutlineSprite.pool;
    const index = pool.findIndex((item) => item.texture.getPixelsWide() === texWidth && item.texture.getPixelsHigh() === texHeight);
    if (index !== -1) {
        const item = pool.splice(index, 1)[0];

        const texture = item.texture;
        texture._contentSize.width = width;
        texture._contentSize.height = height;
        texture.maxS = width / texWidth;
        texture.maxT = height / texHeight;

        return item;
    }

    const texture = new cc.Texture2D();
    texture.initWithData(null, cc.Texture2D.PIXEL_FORMAT_RGBA8888, texWidth, texHeight, cc.size(width, height));

    const framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._webTextureObj, 0);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);

    return {
        texture,
        framebuffer
    };
};

cleverapps.OutlineSprite.release = function (texture, framebuffer) {
    cleverapps.OutlineSprite.pool.push({
        texture,
        framebuffer
    });

    while (cleverapps.OutlineSprite.pool.length > cleverapps.OutlineSprite.POOL_LIMIT) {
        const evicted = cleverapps.OutlineSprite.pool.shift();
        cc._renderContext.deleteFramebuffer(evicted.framebuffer);
        evicted.texture.releaseTexture();
    }
};

cleverapps.styles.OutlineSprite = {
    width: 10,
    padding: 20,
    color: new cc.Color(255, 245, 0, 255)
};
